export default "__VITE_ASSET__Mogn3fYJ__"